import { render, staticRenderFns } from "./AffiliateReportingTable.vue?vue&type=template&id=135866a4&"
import script from "./AffiliateReportingTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateReportingTable.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateReportingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports